module.exports = __webpack_public_path__ + "static/media/phone.9635949a.svg";